export enum EventParticipationStatus {
  GOING = 'going',
  INTERESTED = 'interested'
}

export interface EventParticipations {
  my_participation: BaseEventParticipation | undefined;
  external: ExternalEventParticipation[];
  internal: InternalEventParticipation[];
  going: number;
  interested: number;
}

export interface ExternalEventParticipation extends BaseEventParticipation {
  participant: {
    first_name: string;
    last_name: string;
  };
}

export interface InternalEventParticipation extends BaseEventParticipation {
  user: {
    id: number;
    first_name: string;
    last_name: string;
    avatar_url?: string | null;
  };
}

interface BaseEventParticipation {
  id: number;
  status: EventParticipationStatus;
}
